module.exports = __webpack_public_path__ + "img/idcard.497df8f8.jpg";